export default __webpack_public_path__ + "3dc192355b5c0c4936ca13dbdb9287b8.png";